import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { eventDetail } from '../../services/EventService'
import DateAndTimesPage from '../DateAndTimes/DateAndTimesPage'
import DateAndTimesLive from '../DateAndTimes/eventCast/DateAndTimesLive'
import { isPodcastEnabled } from '../../config/featureFlags'

const RoomBooking = () =>{
    const baseRequestTypes = ['Webinar', 'Webcast', 'Podcast']
    const requestTypes = isPodcastEnabled ? baseRequestTypes : baseRequestTypes.filter(type => type !== 'Podcast')
    const [eventType, setEventType] = useState(requestTypes[0])
    let { id } = useParams();

    useEffect(()=>{
        const loadEventData = async ()=>{
          try{
              const { data } = await eventDetail(Number(id))
              if(data){
                if (data.eventDetail.statusCode === 200) {
                    setEventType(data.eventDetail.data.eventType)
                }
              } 
          }
          catch(error){
            console.log(error)
          }
        }
        if(id !== undefined && id !== null){
          loadEventData()
        }
      },[])


    return(

        <div>
        {eventType === 'Webcast' || (isPodcastEnabled && eventType === 'Podcast')
            ? (<DateAndTimesLive></DateAndTimesLive>)
            : <DateAndTimesPage></DateAndTimesPage>
        }
        </div>

      
        
    )

}
export default RoomBooking